import React, { useState } from "react";
import { useSelector } from "react-redux";
import Routes from "./routes";
import CssBaseline from "@material-ui/core/CssBaseline";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import NewContextProvider from "./context";
import { getTheme } from "./Common/theme";
import { MantineProvider } from "@mantine/core";

const theme = (myTheme) =>
  createMuiTheme({
    app: myTheme,
    height: myTheme.height,
    palette: {
      type: myTheme.themeType,
      primary: {
        light: myTheme.primaryColors.light,
        main: myTheme.primaryColors.main,
        dark: myTheme.primaryColors.dark,
      },
      secondary: {
        light: myTheme.secondaryColors.light,
        main: myTheme.secondaryColors.main,
        dark: myTheme.secondaryColors.dark,
      },
      background: {
        paper: myTheme.background[1],
        default: myTheme.background[0],
      },
      borderColor: {
        light: "white",
        main: "white",
        dark: "white",
      },
    },
  });

export default function App(props) {
  const [prevHeight, setPrevHeight] = useState(window.innerHeight);
  const selectedTheme = useSelector((state) => state.cookies.theme);
  const myTheme = getTheme(selectedTheme);
  window.addEventListener("resize", () => {
    if (window.innerHeight !== prevHeight) {
      setPrevHeight(window.innerHeight);
    }
  });

  const mantineTheme = {
    colorScheme: selectedTheme,
    components: {
      Button: {
        styles: (theme, { variant }) => ({
          root: {
            ":focus": {
              outlineColor: "var(--outline-focus-color)",
            },
          },
        }),
      },
    },
  };

  return (
    <MuiThemeProvider theme={theme({ ...myTheme, height: prevHeight })}>
      <MantineProvider theme={mantineTheme}>
        <CssBaseline />
        <NewContextProvider>
          <Routes userManager={props.userManager} />
        </NewContextProvider>
      </MantineProvider>
    </MuiThemeProvider>
  );
}
